import { useState } from 'react'

import copyLinkIcon from './images/copy-link-icon-blue.svg'
import { generateFixedItemLink, generateItemLink } from './auctionsadminutil'

import css from './sass/adminitem.module.scss'

export default function ItemLinkCopyButton({ item, auction}) {
  const [copied, setCopied] = useState(false)
  const [alertPosition, setAlertPosition] = useState()

  const performCopy = (event) => {
    const auctionCode = auction?.AuctionCode
    const itemCode = item?.ItemCode
    let linkToCopy = ''

    if (item?.ItemId) {
      linkToCopy = generateItemLink(itemCode, auctionCode)
    } else if (item?.FixedItemId) {
      linkToCopy = generateFixedItemLink(itemCode, auctionCode)
    }

    if (!linkToCopy) return

    navigator.clipboard.writeText(linkToCopy)
    const buttonRect = event.currentTarget.getBoundingClientRect()
    setAlertPosition({
      top: buttonRect.bottom - 20,
      left: buttonRect.left + (buttonRect.width / 2),
    })
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 1000)
    
  }

  // if (isUserSR) return <></>

  return (
    <div className={css['copy-link-button-container']}>
      {copied && alertPosition &&
        <p className={`${css['copied-alert']} ${css['copied-alert-floating']}`} style={alertPosition}>
          Copied!
        </p>
      }
      <button className={`${css['admin-item-copy-button']}`} onClick={performCopy}>
        <img className={css['admin-item-action-icons']} src={copyLinkIcon} alt={'Copy Item Link Icon'}/>
      </button>
    </div>
  )
}
